import { render, staticRenderFns } from "./VideoPlay.vue?vue&type=template&id=78a5b83f"
import script from "./VideoPlay.vue?vue&type=script&lang=js"
export * from "./VideoPlay.vue?vue&type=script&lang=js"
import style0 from "./VideoPlay.vue?vue&type=style&index=0&id=78a5b83f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports